
export const pub = <T,>(type: string, data: T) => document.dispatchEvent(new CustomEvent(type, { detail: data }));
export const sub = <T,>(type: string, onData: (d: T) => void) => {
  const cb = (ev: Event) => onData((ev as CustomEvent).detail);
  document.addEventListener(type, cb);
  return cb;
}
type CB = ReturnType<typeof sub>;
export const unsub = (type: string, cb: CB) => document.removeEventListener(type, cb);
